export interface WhatsappCodeModel {
    id: number;
    numberId: number;
    code: string;
    transcript?: string;
    receivedAt: string;
}
